import {LoadingStatus} from "../../status";

export enum GraphsDate {
    hour = "hour",
    day = "day",
    week = "week",
    month = "month"
}

export interface FetchGraphs {
    device_id: number
    timescale: string
    sensor_id?: number
}

export interface FetchCustomGraphs {
    date: string
    time: string
    id: number
}

export interface f500Sensor {
    formated_id: string
    id: number
    name: string
}

export interface F500Nodes {
    formated_number: number
    number: number
    sensors: f500Sensor[]
    type: string
}

export interface Graphs {
    device: string
    device_name: string
    device_type: string
    graphs: {}
}

export interface GraphsState {
    graphsData: Graphs
    liveData: Graphs
    isLivePage: boolean
   isHourlyPage: boolean
    f500Nodes: F500Nodes[]
    status: LoadingStatus
    status_operation: LoadingStatus
}
